import { createContext, useMemo } from "react";

const MenuContext = createContext({ menu: [] });

// El menú del admin es fijo: no depende de permisos por empresa ni del backend.
const buildMenu = () => [
  { id: 'reports', title: 'Reportes', path: '/admin/reports', icon: 'analytics' },
  { id: 'companies', title: 'Empresas', path: '/admin/companies', icon: 'business' },
  { id: 'charges', title: 'Cobros', path: '/admin/charges', icon: 'card' },
  { id: 'config', title: 'Configuración', path: '/admin/config', icon: 'settings' },
  { id: 'maintenance', title: 'Mantenimiento', path: '/admin/maintenance', icon: 'hammer' },
  { id: 'debug', title: 'Debug', path: '/admin/debug', icon: 'bug' },
  { id: 'learning', title: 'Aprendizaje', path: '/learning', icon: 'school' },
  { id: 'staff', title: 'Personal', path: '/admin/staff', icon: 'people' },
  { id: 'apps', title: 'Apps', path: '/admin/apps', icon: 'phonePortrait' },
  { id: 'legal', title: 'Términos y Privacidad', path: '/admin/legal', icon: 'documentText' },
];

export const MenuProvider = ({ children }) => {
  const menu = useMemo(buildMenu, []);
  return <MenuContext.Provider value={{ menu }}>{children}</MenuContext.Provider>;
};

export default MenuContext;
